import { useTranslation } from 'react-i18next'

import { Button, Modal, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const AmendItemsErrorModal = ({ show, onClose }) => {
  const { t } = useTranslation()

  return (
    <Modal show={show} onClose={onClose} title={t('Error')} size="l">
      <Styles.Container>
        <Text type="bodyMRegular">
          {t(
            'Ocurrió un error al intentar actualizar el estado de envío de los productos seleccionados. La operación no se completó correctamente. Revisa el estado del pedido y sus productos en tu plataforma de comercio electrónico.'
          )}
        </Text>
        <Button onClick={onClose}>{t('Entendido')}</Button>
      </Styles.Container>
    </Modal>
  )
}

export default AmendItemsErrorModal
